import React from 'react';

export default function Arrow({ up = false }) {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
      {up ? <path d="M4.5 15.5 15 5M6 5h9v9" /> : <path d="M3.5 10h12m-5-5 5 5-5 5" />}
    </svg>
  );
}
